/** 任务数量趋势 */
export const weekOrderView = '/task/taskOrder/weekOrderView'

/** 投诉量趋势 */
export const weekComplaintView = '/task/taskComplaint/weekComplaintView'

/** 投诉量趋势-商家视角 */
export const taskOrderCount = '/task/taskOrder/taskOrderCount'


/** 今日客户单量排名 */
export const todayOrderCount = '/task/taskOrder/todayOrderCount'

/** 今日站点单量排名 */
export const countryOrderCount = '/task/taskOrder/countryOrderCount'

/** 近30天成交额---平台&商家视角 */
export const querySalerTendForPlatform = '/admin/companyOrderCount/queryCompanyOrderCount'

/** 公告查询列表 */
export const queryNoticeInfo = '/yuntian/notice/queryNoticeInfo'

/** 删除公告 */
export const delNotice = '/yuntian/notice/delNotice'

/** 新建公告 */
export const createNotice = '/yuntian/notice/createNotice'

/** 编辑公告 */
export const modifyNotice = '/yuntian/notice/modifyNotice'

/** 员工列表 **/
export const getDataList = '/admin/list'

/** 员工列表  新增 **/
export const addData = '/admin/register'

/** 员工列表  编辑**/
export const editData = '/admin/update'

/** 员工列表  删除**/
export const deleteData = '/admin/delete'

/** 分配站点权限 **/
export const saveAdminCountry = '/yuntian/adminCountryRelation/saveAdminCountry'

/** 查询权限列表  **/
export const getRoleList = '/role/list'

/** 增加权限列表  **/
export const addRoleData = '/role/create'

/** 编辑权限列表  **/
export const editRoleData = '/role/update'

/** 删除权限列表  **/
export const deleteRoleData = '/role/delete'

/** 查询所有菜单  **/
export const getMenuTreeList = '/menu/treeList'

/** 根据角色id查询所有菜单  **/
export const getRoleMenuList = '/role/listMenu'

/** 给角色分配菜单  **/
export const allocMenu = '/role/allocMenu'


/** 查询海外负责人列表  **/
export const leaderList = '/admin/leaderList'

/** 新增刷手公司  **/
export const addServiceCompany = '/admin/company/addServiceCompany'

/** 编辑刷手公司  **/
export const updateServiceCompany = '/admin/update'

/** 删除刷手公司  **/
export const deleteServiceCompany = '/admin/delete'

/** 查询刷手列表  **/
export const serviceList = '/admin/serviceList'


/** 查询商家汇率列表  **/ 
export const queryCompanyCountryRelList = '/admin/companyCountryRel/queryCompanyCountryRelList'

/** 编辑商家汇率列表  **/ 
export const modifyCompanyCountryRel = '/admin/companyCountryRel/modifyCompanyCountryRel'

/** 同步商家汇率列表  **/ 
export const updateCommentRatio = '/admin/country/updateCommentRatio'


/** 查询商家列表的列表  **/ 
export const queryCompanyInfoList = '/admin/company/queryCompanyInfoList'

/** 新增商家列表  **/ 
export const editCompany = '/admin/company/editCompany'

/** 商家列表重置密码  **/ 
export const updatePasswordByCompanyId = '/admin/updatePasswordByCompanyId'

/** 修改密码  **/ 
export const updatePassWord = '/admin/updatePassword'

/** 编辑商家列表  **/ 
export const modifyCompanyStatus = '/admin/company/modifyCompanyStatus'


/** 查询商家认证审核的列表  **/ 
export const queryExamineList = '/admin/company/queryExamineList'

/** 新增商家认证审核  **/ 
export const modifyCompany = '/admin/company/modifyCompany'

/** 查询刷手佣金结算的列表  **/ 
export const queryTaskList = '/task/taskOrder/taskList'

/** 刷手结算  **/ 
export const batchSettlementAccount = '/task/taskOrder/batchSettlementAccount'

/** 刷手佣金结算列表下载  **/ 
export const serviceSettlementExport = '/task/taskOrder/serviceSettlementExport'

/** 收支明细列表  **/ 
export const accountLogList = '/admin/accountLog/accountLogList'

/** 收支明细导出  **/ 
export const accountLogListExport = '/admin/accountLog/accountLogListExport'

/** 收支明细导出20240304修改  **/ 
export const accountLogListNewExport = '/admin/accountLog/accountLogListNewExport'

/** 收支明细新增  **/ 
export const accountLogAdd = '/admin/accountLog/accountLogAdd'

/** 充值管理列表  **/ 
export const accountList = '/admin/accountOrder/accountList'

/** 充值单详情  **/ 
export const accountOederDetail = '/admin/accountOrder/accountOederDetail'

/** 查询是否有没有处理的充值记录  **/ 
export const accountSelect = '/admin/accountOrder/accountSelect'

/** 充值审核  **/ 
export const dealAccount = '/admin/accountOrder/dealAccount'

/** 给商家充值  **/ 
export const saveCompanyAccount = '/admin/accountOrder/saveCompanyAccount'

/** 接单管理启用和暂停接单  **/ 
export const updateStatus = '/admin/country/updateStatus'

/** 接单管理修改汇率  **/ 
export const updateRatio = '/admin/country/updateRatio'

/** 查询所有回款预扣商户  **/ 
export const getAllRefundCompany = '/admin/company/queryRefundList'

/**  投诉管理查询列表 **/ 
export const companyComplaintList = '/task/taskComplaint/companyComplaintList'

/** 投诉管理 处理投诉  **/ 
export const dealComplaint = '/task/taskComplaint/dealComplaint'

/** 任务列表 **/ 
export const taskList = '/task/taskOrder/taskList'

/** 任务列表tag标签状态数量 **/ 
export const queryTaskStatusCounts = '/task/taskOrder/queryTaskStatusCounts'

/** 提交任务 **/ 
export const commitTask= '/task/taskOrder/commitTask'

/** 取消任务  **/ 
export const  cancelTask= '/task/taskOrder/cancelTask'

/**  确认完成任务 **/ 
export const completeTask = '/task/taskOrder/completeTask'

/**  删除任务 **/ 
export const  delTask= '/task/taskOrder/delTask'

/**  商家投诉 **/ 
export const companyComplaint = '/task/taskComplaint/companyComplaint'

/** 刷手投诉  **/ 
export const serviceComplaint = '/task/taskComplaint/serviceComplaint'

/** 退回任务  **/ 
export const backTask = '/task/taskOrder/backTask'

/** 商家发货  **/ 
export const deliverGoods = '/task/taskOrder/deliverGoods'

/** 签收失败  **/ 
export const failedSign = '/task/taskOrder/failedSign'


/** 商家退回任务给买手  **/ 
export const  backTaskToBeConfirm= '/task/taskOrder/backTaskToBeConfirm'

/** 刷手编辑实付金额  **/ 
export const confirmPayPrice = '/task/taskOrder/confirmPayPrice'


/** 领取任务  **/ 
export const acceptTask = '/task/taskOrder/acceptTask'

/** 任务详情  **/ 
export const taskOrderDetail = '/task/taskOrder/taskOrderDetail'

/** 下单成功  **/ 
export const placeOrderSuccess = '/task/taskOrder/placeOrderSuccess'

/** 下单失败  **/ 
export const placeOrderFail = '/task/taskOrder/placeOrderFail'

/** 查询公司账户  **/ 
export const queryCompanyAccountInfo = '/admin/companyAccount/info'

/** 创建任务   **/ 
export const createTask = '/task/taskOrder/createTask'

/** 编辑任务   **/ 
export const modifyTask = '/task/taskOrder/modifyTask'

/** 账户充值   **/ 
export const saveAccount = '/admin/accountOrder/saveAccount'


/** 刷手列表   **/ 
export const getDataServiceList = '/admin/serviceList'


/** 新增刷手   **/ 
export const createServiceAdmin = '/admin/createServiceAdmin'

/** 编辑刷手   **/ 
export const editServiceAdmin = '/admin/update'

/** 删除刷手   **/ 
export const deleteServiceAdmin = '/admin/delete'

/** 刷手任务列表下载  **/ 
export const taskListExport = '/task/taskOrder/taskListExport'

/** 任务列表下载20240304修改  **/ 
export const taskListNewExport = '/task/taskOrder/taskListNewExport'

/** 任务列表下载20240313修改  **/ 
export const taskListDqsExport = '/task/taskOrder/taskListDqsExport'



/** 商家已下单任务列表下载  **/ 
export const sjtaskListPlaceOrderExport = '/task/taskOrder/shtaskListPlaceOrderExport'

/** 刷手待签收任务列表下载  **/ 
export const taskListImagesExport = '/task/taskOrder/taskListImagesExport'

/** 刷手已下单任务列表下载  **/ 
export const taskListXdExport = '/task/taskOrder/taskListXdExport'


/** 客服任务下单列表下载  **/ 
export const taskListPlaceOrderExport = '/task/taskOrder/taskListPlaceOrderExport'

/** 扫描收货 根据快递单号查询任务 **/ 
export const scanCodeSign = '/task/taskOrder/scanCodeSign'

/** 扫描收货 查询快递员信息列表 **/ 
export const queryCourierInfo = '/yuntian/courier/queryCourierInfo'

/** 扫描收货 新增快递员信息 **/ 
export const createCourier = '/yuntian/courier/createCourier'

/** 扫描收货 删除快递员信息 **/ 
export const delCourier = '/yuntian/courier/delCourier'

/** 扫描签收  **/ 
export const scanSign = '/task/taskOrder/scanSign'

/** 扫描收货 日志 **/ 
export const queryCourierLogList = '/yuntian/courierlog/queryCourierLogList'


/** 扫描签收日志查询任务详情  **/ 
export const queryCourierLogTaskList = '/task/taskOrder/queryCourierLogTaskList'































// WEBPACK FOOTER //
// ./src/http/moudules/pf.js